import React from 'react'
import styled from 'styled-components'

const TwoColumns = ({ children, className }) => {
    return (
        <Column className={ className }>
            { children }
        </Column>
    )
}

const Column = styled.div`
    column-count: 1;
    column-gap: 2.5rem;
    & > * {
        -webkit-column-break-inside: avoid;
        page-break-inside: avoid;
        break-inside: avoid;
    }
    @media (min-width: 768px) {
        column-count: 2;
    }
`
export default TwoColumns
